'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'circle-3';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e0f0';
var svgPathData = ['M16 256a240 240 0 1 0 480 0A240 240 0 1 0 16 256zM160 136c0-4.4 3.6-8 8-8l160 0c3.3 0 6.3 2.1 7.5 5.2s.3 6.6-2.2 8.8L221.4 239.9l58.1-.3c40-.2 72.5 32.2 72.5 72.2c0 39.9-32.3 72.2-72.2 72.2l-71.1 0c-18.2 0-34.8-10.3-42.9-26.5l-4.9-9.9c-2-4-.4-8.8 3.6-10.7s8.8-.4 10.7 3.6l4.9 9.9c5.4 10.8 16.5 17.7 28.6 17.7l71.1 0c31 0 56.2-25.2 56.2-56.2c0-31.1-25.3-56.3-56.4-56.2L200 256c-3.3 0-6.3-2-7.5-5.2s-.3-6.7 2.2-8.9l112-98L168 144c-4.4 0-8-3.6-8-8z', 'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM168 128c-4.4 0-8 3.6-8 8s3.6 8 8 8l138.7 0-112 98c-2.5 2.2-3.4 5.7-2.2 8.9s4.2 5.2 7.5 5.2l79.5-.4c31.1-.1 56.4 25.1 56.4 56.2c0 31-25.2 56.2-56.2 56.2l-71.1 0c-12.1 0-23.2-6.8-28.6-17.7l-4.9-9.9c-2-4-6.8-5.6-10.7-3.6s-5.6 6.8-3.6 10.7l4.9 9.9c8.1 16.3 24.8 26.5 42.9 26.5l71.1 0c39.9 0 72.2-32.3 72.2-72.2c0-40-32.5-72.4-72.5-72.2l-58.1 .3L333.3 142c2.5-2.2 3.4-5.7 2.2-8.8s-4.2-5.2-7.5-5.2l-160 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircle3 = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;